import { withInstall } from '@hd-front-end/utils'
import Progress from './src/progress.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElProgress: SFCWithInstall<typeof Progress> = withInstall(Progress)
export default ElProgress

export * from './src/progress'
